import styled from 'styled-components'
import { Arrow as ArrowRight } from '../../assets'

const Background = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 10;
    background: rgb(0,0,0, .9);
    
    cursor: default;

    @media (min-width: 768px) {
        background: linear-gradient(40deg, rgba(0,0,0,0.7469362745098039) 0%, rgba(0,0,0,0.5732668067226891) 35%, rgba(0,0,0,0) 100%);
    }

    &.open {
        opacity: 1;
        display: block;
        transition: all .5s ease;
    }

    &.closed {
        opacity: 0;
        pointer-events: none; 
        touch-action: none;
        transition: all .5s ease-out;
    }

    .container{
        padding-left: 10px;
        .content{
            margin-top: 40%;
        }
        .border-top{
            height: 3px;
            width: 100%;
            background: #FFF;
            margin-top: 24px;
        }

        .description{
            margin-top: 12px;
            &.voice-off{
                margin-top: 8px;
            }
        }

        .subtitle{
            &.voice-off{
                margin-top: 8px;
            }
        }

        .title{
            margin-top: 8px;
            margin-bottom: 16px;
            line-height: 35px;
        }
    }
`

export const DivScroll = styled.div`
    overflow-x: hidden;
    overflow-y: auto;

    @media (min-width: 768px) {
        /* max-height: 154px; */
        margin-top: 10px;
        max-height: 180px;
        overflow-x: hidden;
        overflow-y: auto;
        padding-right: 12px;
    }

    @media (min-width: 768px) and (max-height: 700px){
        margin-top: 10px;
        max-height: 120px;
    }
`

const ContainerFluid = styled.div`
    position: relative;
    height: 100%;
    @media (min-width: 768px) {
        padding-top: 185px;
        padding-left: 120px;
    }

    @media (min-width: 768px) and (max-height: 700px){
        padding-top: 110px;
    }

    .description{
        margin-top: 12px;
        padding-right: 12px;
        @media (min-width: 768px) {
            padding-right: 12px;
        }
        &.voice-off{
            margin-top: 12px;
        }
    }

    .subtitle{
        @media (min-width: 768px) {
            padding-right: 12px;
        }
        &.voice-off{
            margin-top: 12px;
        }
    }
`

const RowWrapper = styled.div`
    height: 100%;
    

    @media (max-width: 767px) {
        height: 100vh;
        overflow: hidden;
        flex-direction: column;
        justify-content: center;
    }
`

const RowText = styled.div`
    margin-top: 50px;

    .border-top {
        border-top: solid 2px white !important;
    }

    @media (min-width: 768px) {
        margin-top: 30px;
        max-width: 666px;
        padding-right: 8px;

        .border-top {
            border-top: solid 4px white !important;
        }
    }

`

const Col = styled.div`
    box-sizing: border-box;
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    @media (min-width: 768px) {
        padding-right: 15px;
        padding-left: 15px;
        width: auto;
        max-width: 520px;
    }

    @media (min-width: 768px) and (max-height: 700px){
        max-width: 460px;
    }
`

const BtnClose = styled.div`
    position: absolute;
    top: 15px;
    left: 15px;
    z-index: 10;

    @media (min-width: 768px) {
        position: relative;
        top: 0;
        left: 0;
    }

    svg {
        width: 28px;
        height: 28px;
        color: #FFF;
        cursor: pointer;

        @media (min-width: 768px) {
            margin-top: -6px;
            padding: 0;
            width: 32px;
            height: 32px;
        }
    }
`

const Container = styled.div`
    width: 100%;
    padding: 4px;
    background: rgba(255,255,255,0.3);
    img{
        width: 100%;
    }

    &.video{
        height: 170px;
        margin-bottom: -6px;
        line-height: 0;

        &.not-youtube{
            min-height: 170px;
            padding-bottom: 0px;
        }
        iframe {
            max-height: 170px;
        }

        video {
            max-height: 170px;
        }
    }

    @media (min-width: 768px) {
        padding: 8px;
        max-width: 380px;
        img{
            width: 100%;
            max-height: 180px;
            object-fit: cover;
        }
        &.video{
            max-width: 480px;
            height: 238px;
            margin-bottom: -6px;
            line-height: 0;

            &.not-youtube{
                min-height: 238px;
                padding-bottom: 0px;
            }
            iframe {
                max-height: 238px;
            }

            video {
                max-height: 238px;
            }
        }
    } 

    @media (min-width: 768px) and (max-height: 700px){
        max-width: 420px;
        &.video{
            max-width: 420px;
            height: 210px;
            margin-bottom: -6px;
            line-height: 0;

            &.not-youtube{
                min-height: 210px;
                padding-bottom: 0px;
            }
            iframe {
                max-height: 210px;
            }

            video {
                max-height: 210px;
            }
        }
        img{
            width: 100%;
            max-height: 180px;
            object-fit: cover;
        }
    }
    
`

const StartVisitContainer = styled.div`
    margin-top: auto;
    margin-bottom: 86px;

    @media (max-width: 767px) {
        position: absolute;
        top: calc(100vh - 50px);
        left: 10px;
    }
`

const StartVisit = styled.div`
    position: relative;
    width: ${p => p.widthStartVisit > 0 ? p.widthStartVisit: 220 }px;
    font-family: 'Amorim Sans Book', sans-serif;
    color: #FFF;
    text-transform: uppercase;
    font-size: 16px;
    letter-spacing: 1.5px;
    cursor: pointer;

    &:hover {
        :after {
            transform: translate(0, -40%);
        }
    }

    &:after {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(-8px, -40%);
        content: '';
        width: 30px;
        height: 10px;
        mask: url(${ArrowRight}) no-repeat;
        mask-size: 50% 90%;
        background: #FFF;
        margin-left: 10px;
        transition: all .2s ease-out;
    }
`

export { Background, StartVisit, StartVisitContainer, Col, RowText, Container, ContainerFluid, RowWrapper, BtnClose }